import type { Noop } from '#types/noop.type';

/**
 * A no-operation (noop) function that performs no actions.
 *
 * Can be used as a default callback or placeholder where a function is required but no operation is needed.
 *
 * @remarks
 * The function signature is defined by the `Noop` type.
 */
// biome-ignore lint/suspicious/noEmptyBlockStatements: this is a no-operation function
export const noop: Noop = (): void => {};
